/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ccsl_Export_Metadata_Drop_FrameInputs */



/**
* | output |
* | --- |
* | "Drop Frame: {value}" |
*
* @param {Ccsl_Export_Metadata_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_drop_frame = /** @type {((inputs: Ccsl_Export_Metadata_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Drop Frame : ${i?.value}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Riquadro di caduta: ${i?.value}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Fotograma a eliminar: ${i?.value}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`帧丢失：${i?.value}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ドロップフレーム: ${i?.value}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम: ${i?.value}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
	return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
});